export default  {
    id: '',
    closing_price: '' ,
    closing_date: '',
	closing_square_feet: '',
	realtor_involved: '',
    realtor: 0,
    realtor_office: 0,
    manual_realtor: '',
	hud_doc: ''
}